const UTM_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
] as const

const STORAGE_KEY = 'garden_shield_utms'
const BASE_HOTMART_URL = 'https://pay.hotmart.com/B105054698I?checkoutMode=10'

export function captureUtmParams() {
  const params = new URLSearchParams(window.location.search)
  const utms: Record<string, string> = {}

  // Check URL first
  let hasNewUtms = false
  for (const key of UTM_KEYS) {
    const value = params.get(key)
    if (value) {
      utms[key] = value
      hasNewUtms = true
    }
  }

  // If new UTMs found in URL, save to sessionStorage
  if (hasNewUtms) {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(utms))
    return
  }

  // Otherwise, nothing to do — existing session UTMs are already stored
}

function getStoredUtms(): Record<string, string> {
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY)
    return stored ? JSON.parse(stored) : {}
  } catch {
    return {}
  }
}

export function getHotmartUrl(): string {
  const utms = getStoredUtms()
  const url = new URL(BASE_HOTMART_URL)

  for (const [key, value] of Object.entries(utms)) {
    if (value) {
      url.searchParams.set(key, value)
    }
  }

  return url.toString()
}
